import styled from '@emotion/styled'
import { Box } from '@mui/material'
import theme from 'theme'

export const ToolbarWrapper = styled(Box)`
  display: flex;
  flex-flow: column wrap;
  width: 100%;
  gap: ${theme.spacing.medium}px;
  max-width: 400px;

  .controls-initial-header {
    color: ${theme.colors.foreground};
    font-size: ${theme.typography.fontSize.xLarge};
    font-style: normal;
    font-weight: ${theme.typography.fontWeight.thin};
    line-height: normal;
  }

  &.controls-toolbar-wrapper-main {
    flex-flow: unset;
    max-width: unset;
    align-items: center;

    .action-wrapper {
      margin-top: 0 !important;
      height: 68px;
      align-items: flex-end !important;
      display: flex !important;
    }
  }

  .last-seen {
    display: flex;
    flex-direction: column;
    height: 68px;
    justify-content: space-between;

    .misc-control-title {
      white-space: nowrap;
      color: ${theme.colors.foreground};
      font-size: ${theme.typography.fontSize.xLarge};
      font-style: normal;
      font-weight: ${theme.typography.fontWeight.normal};
      line-height: normal;
      margin-bottom: ${theme.spacing.half}px;
    }
  }

  .action-wrapper {
    margin-top: ${theme.spacing.medium}px;

    button {
      width: 100%;
    }
  }
`
